import type {
  WidgetType} from '@dreamstack/feature-components';
import {
  SimpleAccordionEntry
} from '@dreamstack/feature-components'
import type { AccordionEntryFragment } from '@dreamstack/investors-graphql'
import type { FunctionComponent } from 'react'
import { getBlockChildren } from '../blocks/block.utils'
import { ChildrenBlockSpacingContainer } from '../contentful/ChildrenBlockSpacingContainer'
import { ContentfulBlocks } from '../contentful/ContentfulBlocks'
import type { QueryAllBlocksRecursivelyResult } from '../contentful/QueryAllBlocksRecursivelyResult'

export const AccordionEntry: FunctionComponent<React.PropsWithChildren<{
  block: QueryAllBlocksRecursivelyResult<AccordionEntryFragment>
  customProps?: {
    processAccordionEntryClick: (integer: number, boolean: boolean) => void
    index: number
    useAqua: boolean
    smallSize: boolean
    widgetType: WidgetType
  }
}>> = ({ block, customProps }) => {
  return (
    <SimpleAccordionEntry
      clickHandler={customProps?.processAccordionEntryClick}
      index={customProps?.index}
      title={block.title || ''}
      titleWhenExpanded={block?.titleWhenExpanded ?? ''}
      useAqua={customProps?.useAqua}
      smallSize={customProps?.smallSize}
      widgetType={customProps?.widgetType}
    >
      <ChildrenBlockSpacingContainer>
        <ContentfulBlocks
          blocks={getBlockChildren(block, block.blocksCollection?.items)}
        />
      </ChildrenBlockSpacingContainer>
    </SimpleAccordionEntry>
  )
}
